import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import {baseUrl} from '../common/config.js';
import {apiService} from '../common/apiCallService';
import Paper from 'material-ui/Paper';
import Loading from './Loading.js';
import Menu from './Menu.js';
import RenderTextField from './CustomFields.js'
import validator from 'validator';
import { Redirect } from 'react-router';
import * as actions from '../store/actions/index';
import { connect } from 'react-redux';
import { createVirtualPageLoad, closeVirtualPage } from '../common/commonService'

class ChangePwd extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      oldPwd: '',
      newPwd: '',
      confirmPwd: '',
      oldPwd_error: '',
      newPwd_error: '',
      confirmPwd_error: '',
      title: 'Change Password',
      loginRedirect: false,
      userType: localStorage.getItem('loggedInType'),
      userRole: localStorage.getItem('userRole')
    }
  }

  componentDidMount() {
    createVirtualPageLoad("/changePassword")
    
    if(this.state.userType === 'PartyPoker' && this.state.userRole.indexOf('SYS_ADMIN') == -1) this.setState({loginRedirect: true})
  }

  componentWillUnmount() {
    closeVirtualPage()
  }

  changePwd = () => {
    this.setState({loading: true})
    apiService(baseUrl + '/appUser/changePwd', {
      oldPwd: this.state.oldPwd,
      newPwd: this.state.newPwd,
      confirmPwd: this.state.confirmPwd
    },  (data) => {
        this.setState({loading: false})
        alert('Password Changed Successfully!!! Please Login Again')
        localStorage.clear()
        this.setState({loginRedirect: true})
    }, (data) => {
        this.setState({loading: false})
        if(data.status == 406) {
          alert('Enter Correct Old Password')
        } else if(data.status == 403) {
          this.setState({loginRedirect: true})
        }
    })
  }

  validate = () => {
    this.setState({newPwd_error: ''})
    this.setState({oldPwd_error: ''})
    this.setState({confirmPwd_error: ''})

    if(validator.isEmpty(this.state.oldPwd)) return this.setState({oldPwd_error: 'Old Password is required'})
    if(validator.isEmpty(this.state.newPwd)) return this.setState({newPwd_error: 'New Password is required'})
    if(validator.isEmpty(this.state.confirmPwd)) return this.setState({confirmPwd_error: 'Re-Enter New Password'})

    if(this.state.oldPwd === this.state.newPwd) return this.setState({oldPwd_error: 'Old Password and New Password should not be same'})
    if(this.state.newPwd !== this.state.confirmPwd) return this.setState({newPwd_error: 'New Password and Re-Entered Password should be same'})

    this.changePwd()

  }

  render() {
    this.props.setHeaderTitle(this.state.title)
    return (
      <div>
      {this.state.loginRedirect && (
     <Redirect to={'/'}/>
   )}
      {this.state.loading
          ? <Loading/>
          : null}
          <center><br/><br/>
            <Paper zDepth={5} style={{margin: 20, textAlign: 'center',display: 'inline-block', padding: 20}}>
             <div>
             <TextField
             type="password"
              hintText="Enter Old Password"
              floatingLabelText="Old Password" ref="oldPwd"
              value = {this.state.oldPwd}
              errorText = {this.state.oldPwd_error}
              onChange = {(event,newValue) => this.setState({oldPwd: newValue})}
              />
              <br/>
              <TextField
              type="password"
               hintText="Enter New Password"
               floatingLabelText="New Password" ref="newPwd"
               value = {this.state.newPwd}
               errorText = {this.state.newPwd_error}
               onChange = {(event,newValue) => this.setState({newPwd: newValue})}
               />
               <br/>
               <TextField
               type="password"
                hintText="Re-Enter New Password"
                floatingLabelText="Confirm Password" ref="confirmPwd"
                value = {this.state.confirmPwd}
                errorText = {this.state.confirmPwd_error}
                onChange = {(event,newValue) => this.setState({confirmPwd: newValue})}
                />
                <br/>
                <RaisedButton label="SUBMIT" primary={true} onClick={() => this.validate()}/>
             </div>
           </Paper>
         </center>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
  }
};

export default connect(null, mapDispatchToProps)(ChangePwd);



/** WEBPACK FOOTER **
 ** ./src/components/ChangePwd.js
 **/